/**
 * 1.3.75: MVP 多租户架构 - 成员管理页面
 * 成员列表、邀请成员、角色变更等功能
 * 
 * 1.4.1: 已废弃，成员管理功能已整合到账号中心
 * 此页面仅保留重定向逻辑，访问时自动跳转到账号中心的成员管理 Tab
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// 1.4.1: 重定向到账号中心的成员管理 Tab
export function MembersPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // 重定向到账号中心的成员管理 Tab
    navigate('/account#members', { replace: true });
  }, [navigate]);

  // 显示加载中状态（重定向期间）
  return (
    <div className="p-8 flex items-center justify-center min-h-[400px]">
      <div className="text-center">
        <span className="inline-block text-primary font-semibold yui-loading-animation text-2xl">YUI</span>
      </div>
    </div>
  );
}

/* ============================================
 * 1.4.1: 以下为原有代码，已废弃
 * ============================================

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  getCurrentOrganization,
  getOrganizationDetails,
  inviteMember,
  removeMember,
  updateMemberRole,
  createInvitationLink,
  getOrganizationInvitations,
  cancelInvitation,
  type UserOrganization,
  type OrganizationDetails,
  type MemberRole,
} from '../services/organizationService';

export function MembersPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [organization, setOrganization] = useState<UserOrganization | null>(null);
  const [details, setDetails] = useState<OrganizationDetails | null>(null);
  const [invitations, setInvitations] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const { organization: org } = await getCurrentOrganization();
      if (org) {
        setOrganization(org);
        
        const { details: orgDetails } = await getOrganizationDetails(org.id);
        setDetails(orgDetails);
        
        const { invitations: inv } = await getOrganizationInvitations(org.id);
        setInvitations(inv);
      }
    } catch (err: any) {
      setError(err.message || '加载失败');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveMember = async (userId: string, email: string) => {
    if (!organization) return;
    if (!confirm(`确定要移除成员 ${email} 吗？`)) return;

    try {
      const { result, error: apiError } = await removeMember(organization.id, userId);
      if (apiError) {
        setError(apiError.message);
        return;
      }
      setSuccess('成员已移除');
      loadData();
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleRoleChange = async (userId: string, newRole: MemberRole) => {
    if (!organization) return;

    try {
      const { result, error: apiError } = await updateMemberRole(organization.id, userId, newRole);
      if (apiError) {
        setError(apiError.message);
        return;
      }
      setSuccess('角色已更新');
      loadData();
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleCancelInvitation = async (invitationId: string) => {
    if (!confirm('确定要取消这个邀请吗？')) return;

    try {
      const { success: ok, error: apiError } = await cancelInvitation(invitationId);
      if (apiError) {
        setError(apiError.message);
        return;
      }
      setSuccess('邀请已取消');
      loadData();
    } catch (err: any) {
      setError(err.message);
    }
  };

  const isOwner = organization?.role === 'owner';
  const currentUserId = details?.members?.find(m => m.role === organization?.role)?.user_id;

  if (isLoading) {
    return (
      <div className="p-8 flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <span className="inline-block text-primary font-semibold yui-loading-animation text-2xl">YUI</span>
        </div>
      </div>
    );
  }

  if (!organization || !details) {
    return (
      <div className="p-8">
        <div className="text-center text-gray-500">
          未找到组织信息
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      ...原有 JSX 代码...
    </div>
  );
}

============================================ */
